import { WalletAddressesSaved } from 'BreetComponents';
import { useWithdrawUsdRequestContext } from 'BreetHooks';
import { useCallback } from 'react';

import { useWithdrawRequestUsdFormStageContext } from '../FormStageContext';

const DialogWithdrawUsdWalletAddressesSaved = () => {
	const { navigator } = useWithdrawRequestUsdFormStageContext();
	const { handleSelectAddress, resetWalletAddressProps, formDataContextProps } = useWithdrawUsdRequestContext();

	const onAddNewAddress = useCallback(() => {
		resetWalletAddressProps();
		navigator.goTo('add-wallet-address')();
	}, [resetWalletAddressProps, navigator]);

	const formData = formDataContextProps.hookFormProps.watch();

	return (
		<WalletAddressesSaved
			onAddNewAddress={onAddNewAddress}
			onSelectAddress={handleSelectAddress}
			onManageAddress={navigator.goTo('manage-wallet-address')}
			selectedWalletAddress={formData.receiverAddress}
			onButtonClick={navigator.goTo('crypto-transaction-details')}
			isButtonDisabled={!formDataContextProps.isFormCompleted}
		/>
	);
};

export default DialogWithdrawUsdWalletAddressesSaved;
